module.exports = __webpack_public_path__ + "img/ic_line_default.acbcee9e.svg";